
import { Link } from 'react-router-dom';

export default function Contact() {
  return (
    <div className="min-h-screen flex items-center justify-center relative overflow-hidden py-12 px-6">
      {/* Background Image */}
      <div 
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: 'url(https://public.readdy.ai/ai/img_res/aa4136f1d5bda1b7b4e94a4d8795e51a.jpg)'
        }}
      />
      
      {/* Dark Overlay */}
      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/40 to-black/50"></div>
      
      {/* Back to Home Button */}
      <Link 
        to="/"
        className="absolute top-6 left-6 z-20 bg-white/20 backdrop-blur-sm hover:bg-white/30 text-white font-semibold px-6 py-3 rounded-full transition-all duration-300 flex items-center gap-2 cursor-pointer whitespace-nowrap"
      >
        <i className="ri-arrow-left-line text-xl"></i>
        Kembali ke Home
      </Link>
      
      {/* Content */}
      <div className="relative z-10 w-full max-w-2xl space-y-8">
        {/* Brand Name */}
        <h1 className="text-5xl md:text-6xl font-bold text-white text-center mb-2 tracking-wider" style={{ fontFamily: "'Pacifico', cursive" }}>
          Twin Bermers
        </h1>
        
        {/* Tagline */}
        <p className="text-xl md:text-2xl text-teal-300 text-center mb-8 font-semibold drop-shadow-lg">
          Buat Website Berbasis AI Hanya 15.000
        </p>
        
        {/* TikTok Section */}
        <div className="bg-white/95 backdrop-blur-sm rounded-2xl shadow-xl p-8 transform transition-all duration-300 hover:shadow-2xl">
          <h2 className="text-3xl font-bold text-gray-900 mb-6 text-center">
            DM Aja
          </h2>
          <a
            href="https://www.tiktok.com/@panggil.el.aja2?lang=en"
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center justify-center gap-3 bg-black hover:bg-gray-800 text-white font-semibold px-8 py-4 rounded-full text-lg transition-all duration-300 transform hover:scale-105 whitespace-nowrap cursor-pointer"
          >
            <i className="ri-tiktok-fill text-2xl"></i>
            Buka TikTok
          </a>
        </div>

        {/* WhatsApp Section */}
        <div className="bg-white/95 backdrop-blur-sm rounded-2xl shadow-xl p-8 transform transition-all duration-300 hover:shadow-2xl">
          <h2 className="text-3xl font-bold text-gray-900 mb-6 text-center">
            WA Aja
          </h2>
          <div className="text-center">
            <p className="text-2xl font-semibold text-teal-600 mb-4">
              +62 895-2857-3545
            </p>
            <a
              href="https://wa.me/6289528573545"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center justify-center gap-3 bg-green-500 hover:bg-green-600 text-white font-semibold px-8 py-4 rounded-full text-lg transition-all duration-300 transform hover:scale-105 whitespace-nowrap cursor-pointer"
            >
              <i className="ri-whatsapp-fill text-2xl"></i>
              Chat WhatsApp
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}
